import { render, staticRenderFns } from "./changePass.vue?vue&type=template&id=727b45be"
import script from "./changePass.vue?vue&type=script&lang=js"
export * from "./changePass.vue?vue&type=script&lang=js"
import style0 from "./changePass.vue?vue&type=style&index=0&id=727b45be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports